import * as Yup from 'yup';
import { v4 as uuid } from 'uuid';
import { SeedFundingSchema } from './types';

const init = (): SeedFundingSchema => ({
  seedFunding: {
    items: [{ id: uuid(), name: 'Seed Funding', description: '---', amount: 0 }],
    total: 0
  }
});

const validation = Yup.object({
  seedFunding: Yup.object({
    items: Yup.array()
      .of(
        Yup.object({
          name: Yup.string().required('Name is required'),
          description: Yup.string(),
          amount: Yup.number().min(0, 'Amount cannot be less than 0').required()
        })
      )
      .min(0, 'At least one unit is required')
  })
});

export default { init, validation };
